function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgWarningOutline(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 84,
    height: 84,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M14.04 73.213H69.96a5.25 5.25 0 004.622-7.739l-27.96-51.926c-1.983-3.681-7.262-3.681-9.246 0L9.417 65.474a5.25 5.25 0 004.622 7.739v0z",
    stroke: props.color,
    strokeWidth: 2.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M41.057 32.057L42 52.073l.94-20.007a.94.94 0 00-.95-.985v0a.944.944 0 00-.932.976v0z",
    stroke: props.color,
    strokeWidth: 2.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M42 65.174a3.28 3.28 0 110-6.562 3.28 3.28 0 010 6.562z",
    fill: props.color
  }));
}

export default SvgWarningOutline;